import { useState } from "react"
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Button } from "../../../components/Button";
import { Center, Input } from "../../../components/Form";
import authService from "../../../service/auth";
import { toastError, toastSuccess } from "../../../BTUI/BtToast";

const AskForPaymentNrc = (props) => {
    const [errors, setErrors] = useState({})
    const [loadingButton, setLoadingButton] = useState(false)
    const [payload, setPayload] = useState({});

    console.log('Props',props)
    console.log('PAYLOAD',payload)
    const handleChange = (name, value) => {
        setPayload({
            ...payload,
            [name]: value,
        });
    };

    const handleSubmit = () => {
        setLoadingButton(true)

        authService.createNrcPaymentRequest(payload)
        .then((res) => {
            
            toastSuccess(res?.data?.message);
            setLoadingButton(false)
            props?.setToggleUpdateWindow(false)
        })
        .catch((err) => {
            if (err?.data?.field_errors) {
                setErrors(err?.data?.field_errors);
            } 
            toastError(err?.data?.message)
            console.log("Error", err)
            setLoadingButton(false);
        });

      };


    
    return<>
                <div
        className=""
        style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        }}
        >
        </div>

        
        <Center>
            <Input 
                label="Customer Email"
                name="email"
                value={payload?.email}
                error={errors?.email}
                handleChange={handleChange}
            />

        </Center>
<br/>
        <Center>
            <Input 
                label="Title"
                name="title"
                value={payload?.title}
                error={errors?.title}
                handleChange={handleChange}
            />

        </Center>
        <br/>

        <Center>
            <Input 
                label="Amount ( $CAD)"
                name="amount"
                value={payload?.amount}
                error={errors?.amount}
                handleChange={handleChange}
            />

        </Center>
        <br />
        <div style={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}>
        <Button
            loading={loadingButton}
            name="sendRequest"
            title="Send Request"
            onClick={handleSubmit}
        />
        </div>
        <br />
    </>
}


export default AskForPaymentNrc